import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, DoCheck, forwardRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { isUndefined, isNullOrUndefined } from '../../../_infrastructure/objectUtils';
import { RemunerationOtherParent } from '../RemunerationsShared/remuneration-other-table-edit.component';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '../../../_infrastructure/ValidationMessages/ExternalValidationDirective';
import { confirmRemoveFromList } from '../../../_infrastructure/TableEdit/TableEditBase';
import { ModalService } from '../../../_infrastructure/Modal/ModalService';
import { WorkflowComponent } from '../../workflow.component';
import { SubscriberInformationService } from '../../../_infrastructure/SubscriberInfo/SubscriberInformationService';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
//import DateHelpers from '../../../_infrastructure/DateHelpers';
import { CurrencyFormat } from '../../../_infrastructure/objectUtils';

@Component({
    selector: 'remunerations-last-until-cutoff',
    templateUrl: './remunerations-last-until-cutoff.component.html',
    providers: [{ provide: RemunerationOtherParent, useExisting: forwardRef(() => RemunerationsLastUntilCutoffComponent) },
        { provide: ICardComponentInjectionToken, useExisting: forwardRef(() => RemunerationsLastUntilCutoffComponent) }],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})

export class RemunerationsLastUntilCutoffComponent implements OnInit, OnDestroy, ICardComponent,DoCheck, RemunerationOtherParent {
  public cardData: models.RemunerationsLastUntilCutoffVM = {} as models.RemunerationsLastUntilCutoffVM;
  public cardConfiguration: models.CardVM;
  public isWorkflowOnSubscriber: boolean = false;
  public disableTableRemoveIcons: boolean = false;
  public expandedRowIndex: number = null;
  public expandNewEntry = false;
  public parentWorkflow: WorkflowComponent;
  public professionalClass: string;
  public workflowDropdowns: models.WorkflowDropdownsVM = <models.WorkflowDropdownsVM>{};
  public subscriberType: string;
  public subscriber: models.SubscriberInformationVM;
  public profGroup: string;
  public profClass: string;
  public profLevel: string;
  public levels: any[];
  public categories: {}[];
  public chosenCategory: {};
  public taxIndexes: {}[];
  public taxSteps: {}[];
  
  public dataLimiteCessacao: Date = new Date("2006-01-01");
  public dataCessacao: Date = new Date();
  public isExSubscritor: boolean;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.yesNo)
  public yesNo: models.DimensionVM[];

  constructor(private modalService: ModalService, private subscriberInfoService: SubscriberInformationService) {
  }

  ngOnInit(): void {

    

    //TEMP to prevent undefined errors if no stepdata is found
    if (this.isVersion2())
      this.subscriberInfoService.getCurrentSubscriber().subscribe((subscriber) => this.subscriber = subscriber);

    //this.dataCessacao = new Date(this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['dataCessacao']);
    const haDataCessacao = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.['dataCessacao'] : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.['dataCessacao'];
    if (haDataCessacao !== null && haDataCessacao !== undefined) {
      this.dataCessacao = new Date(haDataCessacao);
    } else {
      this.dataCessacao = new Date("2006-01-02");
    }

    if (isNullOrUndefined(this.cardData.remunerationsList))
    this.cardData.remunerationsList = [];
    if (this.isVersion2()) {
      this.workflowDropdowns = this.parentWorkflow.workflowDropdowns;
      if (!this.checkSteps()) {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo && this.parentWorkflow.workflowInstance.formData.StepSubscriberInfo['CGAPensionStatus'].subscriberTypeCode;
      } else {
        this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }

      this.isExSubscritor = (this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1 && this.parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI005') == -1) ? false : true;

      //if (isNullOrUndefined(this.cardData.category) && (this.checkCGDStarterEntity() || !this.checkIfMagDipMil())) {
      if (isNullOrUndefined(this.cardData.category) &&
        (
          (!this.isExSubscritor && (this.checkCGDStarterEntity() || !this.checkIfMagDipMil()))
          || (this.isExSubscritor) //PIT39631
        )) {
        this.cardData.category = this.getEffMap2005Category();
      }
    }
  }

  ngDoCheck(): void {
    //Needs to be done in DoCheck because of step data being received asyncrously
    if (isNullOrUndefined(this.cardData.remunerationsList))
      this.cardData.remunerationsList = [];
    if (this.isVersion2()) {
      if (isNullOrUndefined(this.categories)) {
        this.categories = this.getCategories();
        this.changedCategory(this.cardData.category);
      }
      if (isNullOrUndefined(this.levels) && this.checkCGDStarterEntity()) {
        this.levels = this.getTaxLevels();
        this.changedTaxLevels(this.cardData.taxLevel);
      }
      if (isNullOrUndefined(this.taxSteps)) {
        this.taxSteps = this.getTaxSteps();
        this.changedTaxSteps(this.cardData.taxStep);
      }
      if (isNullOrUndefined(this.taxIndexes) && !this.checkCGDStarterEntity()) {
        this.taxIndexes = this.getTaxIndexes();
        this.changedTaxIndexes(this.cardData.taxIndex);
      }

      if (!this.checkSteps()) {
        if (isNullOrUndefined(this.professionalClass)) {
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.professionalCategoryCode;
        }
        if (isNullOrUndefined(this.subscriberType)) {
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
        }
      } else {
        if (isNullOrUndefined(this.professionalClass))
          this.professionalClass = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.professionalCategoryCode;
        if (isNullOrUndefined(this.subscriberType))
          this.subscriberType = this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode;
      }
    }
  }
      
  ngOnDestroy(): void {
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  checkSteps() {
    let result = false;
    for (let i = 0; i < this.parentWorkflow.steps.length; i++) {
      if (this.parentWorkflow.steps[i].stepCode === "StepSubscriberCGA") {
        result = true;
        break;
      }
    }
    return result;
  }

  checkIfMagDipMil() {
    let result = false;
    let profCats = ['4', '5', '17'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true;
    return result;
  }

  checkIfMagDip() {
    let result = false;
    let profCats = ['4', '5'];
    if (profCats.indexOf(this.professionalClass) >= 0)
      result = true

    return result;
  }

  checkCGDStarterEntity() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['StepServiceInfo']?.['ServiceIdentification']?.code === '2251') {
      result = true
    }
    return result;
  }

  checkVisibilityBaseRevenue() {
    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");
      
      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil    // 02 Militar    // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2005) {
        this.cardData.baseRevenue = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity() && this.dataCessacao <= date2005) {
        this.cardData.baseRevenue = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2005) {
        this.cardData.baseRevenue = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date2005) {
        this.cardData.baseRevenue = undefined;
        return false;
      }
    }

    return true;
  }

  checkVisibilityLegalBase() {
    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil      // 02 Militar      // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2005) {
        this.cardData.legalBase = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity() && this.dataCessacao <= date2005) {
        this.cardData.legalBase = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2005) {
        this.cardData.legalBase = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date2005) {
        this.cardData.legalBase = undefined;
        return false;
      }
    }

    return true;
  }

  checkVisibilityCategory() {
    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil      // 02 Militar      // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2005) {
        this.cardData.category = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity() && this.dataCessacao <= date2005) {
        this.cardData.category = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2005) {
        this.cardData.category = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date2005) {
        this.cardData.category = undefined;
        return false;
      }
    }

    return true;
  }

  checkVisibilityTaxLevel() {
    if (!this.isExSubscritor) {
      return this.checkCGDStarterEntity();
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil      // 02 Militar      // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity())) {
        this.cardData.taxLevel = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity() && this.dataCessacao <= date2005) {
        this.cardData.taxLevel = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03')) {
        this.cardData.taxLevel = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip()) {
        this.cardData.taxLevel = undefined;
        return false;
      }
    }

    return true;
  }

  checkVisibilityTaxStep() {
    if (!this.isExSubscritor) {
      return true;
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil      // 02 Militar      // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2005) {
        this.cardData.taxStep = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity() && this.dataCessacao <= date2005) {
        this.cardData.taxStep = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2005) {
        this.cardData.taxStep = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date2005) {
        this.cardData.taxStep = undefined;
        return false;
      }
    }

    return true;
  }

  checkVisibilityTaxIndex() {
    if (!this.isExSubscritor) {
      return !this.checkCGDStarterEntity();
    }
    else {
      let date2005 = new Date("2005-12-31T23:59:59");

      var subscriberType: any;
      subscriberType = this.checkSteps() ? this.parentWorkflow.workflowInstance.formData['StepSubscriberCGA']?.['CGAPensionStatus']?.subscriberTypeCode : this.parentWorkflow.workflowInstance.formData['StepSubscriberInfo']?.['CGAPensionStatus']?.subscriberTypeCode;
      // 01 civil       // 02 Militar      // 03 Militarizado

      //Civil (excluindo pedidos cujo serviço responsável é a CGD e ex-subscritores cuja classe profissional é Magistrados ou Corpos diplomáticos
      if (subscriberType == '01' && (!this.checkIfMagDip() && !this.checkCGDStarterEntity()) && this.dataCessacao <= date2005) {
        this.cardData.taxIndex = undefined;
        return false;
      }

      // "Civis Serviço responsável pelo pedido = CGD"
      if (subscriberType == '01' && !this.checkIfMagDip() && this.checkCGDStarterEntity()) {
        this.cardData.taxIndex = undefined;
        return false;
      }

      //Militar - Militarizado
      if ((subscriberType == '02' || subscriberType == '03') && this.dataCessacao <= date2005) {
        this.cardData.taxIndex = undefined;
        return false;
      }

      //Civil - Magistrados judiciais e do ministério público / Corpos diplomáticos
      if (subscriberType == '01' && this.checkIfMagDip() && this.dataCessacao <= date2005) {
        this.cardData.taxIndex = undefined;
        return false;
      }
    }

    return true;
  }

  getEffMap2005Category() {
    let result;
    let date2005 = new Date("2005-12-31T23:59:59");
    let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
    if (effMapEntries?.length > 0) {
      for (let i = 0; i < effMapEntries.length; i++) {
        if (effMapEntries[i]?.startDate?.getTime() <= date2005.getTime()) {
          result = effMapEntries[i].category;
        }
      }
    }
    return result;
  }

  getLastEffMap2005Entry() {
    let result;
    let date2005 = new Date(2005, 12, 31);
    let effMapEntries: models.EffectivityEntryVM[] = this.parentWorkflow.workflowInstance.formData['StepMap']?.['EffectivityMap']?.['effectivityList'];
    for (let i = 0; i < effMapEntries.length; i++) {
      if (effMapEntries[i].startDate.getTime() <= date2005.getTime()) {
        result = effMapEntries[i];
      }
    }
    return result;
  }

  onRemunerationsListChanged(newList: models.RemunerationOtherVM[]) {
    this.sortListByStartDate(newList);
    this.cardData.remunerationsList = newList;
    this.expandedRowIndex = null;
    this.expandNewEntry = false;
  }

  removeFromList(currentList: any[], indexToRemove: number, event: MouseEvent) {
    if (this.expandedRowIndex == null || this.expandedRowIndex == indexToRemove) {
      confirmRemoveFromList(currentList, indexToRemove, this.modalService).subscribe(result => {
        if (result)
          this.expandedRowIndex = null;
      });
    }
    event.stopPropagation();
  }
  expandRow(i) {
    if (this.expandedRowIndex == i)
      this.expandedRowIndex = null;
    else if (this.expandedRowIndex == null)
      this.expandedRowIndex = i;
  }

  sortListByStartDate(remunerationsList: models.RemunerationOtherVM[]) {
    remunerationsList.sort((first, second) => first.startDate?.getTime() - second.startDate?.getTime());
  }

  getTaxLevels() {
    let result = [];
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListInferiorNivel")
          result.push(this.parentWorkflow.workflowDropdowns.options[i]);
    }
    result.sort((a, b) => a.description.localeCompare(b.description, undefined, { numeric: true }));
    return result;
  }

  changedTaxLevels(e) {
    this.profLevel = e;
    for (let i = 0; i < this.levels.length; i++) {
      if (this.levels[i]['value'] === e) {
        this.profGroup = this.levels[i]['type'];
      }
    }

    this.taxSteps = this.getTaxSteps();
  }

  changedTaxSteps(e) {
    if (!this.checkCGDStarterEntity()) {
      this.taxIndexes = this.getTaxIndexes();
    }
  }

  getTaxIndexes() {

    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      this.profGroup = '1';
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      this.profGroup = "1";
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      this.profGroup = '1';
    }

    let result = [];
    let end2005 = new Date(2005, 12, 31, 23, 59, 59);
    for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
      if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListIndice") {
        if (this.parentWorkflow.workflowDropdowns.options[i]['value'] === this.profClass) {
          if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.chosenCategory?.['value']) {
            if (this.parentWorkflow.workflowDropdowns.options[i]['filter'] === this.profGroup) {
              if (this.parentWorkflow.workflowDropdowns.options[i]['filter4'] === this.cardData.taxStep) {
                if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']) >= end2005) {
                  if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter3']) <= end2005 && this.profClass === "MAJ") {
                    result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                  } else if (this.profClass !== "MAJ" && new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter3']) <= end2005) {
                    result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                  }
                }
              }

            }
          }
        }
      }
    }
    

    result.sort((a, b) => a.description.localeCompare(b.description, undefined, { numeric: true }));

    return result;
  }

  changedTaxIndexes(e) {
    //this.taxSteps = this.getTaxSteps();
  }

 

  getTaxSteps() {

    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "1";
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "1";
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      if (!this.checkCGDStarterEntity())
        this.profGroup = "1";
    }

    if (this.checkCGDStarterEntity()) {
      this.profClass = "CGD";
    }
    let result = [];
    let end2005 = new Date(2005, 12, 31, 23, 59, 59);
    if (!this.checkCGDStarterEntity()) {
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListEscalao") {
          if (this.parentWorkflow.workflowDropdowns.options[i]['filter3'] === this.profClass) {
            if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.chosenCategory?.['value'] || this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.chosenCategory) {
              if (this.parentWorkflow.workflowDropdowns.options[i]['filter'] === this.profGroup) {
                if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']) >= end2005) {
                  if (new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter4']) <= end2005 || this.parentWorkflow.workflowDropdowns.options[i]['filter4'] === "" || isNullOrUndefined(this.parentWorkflow.workflowDropdowns.options[i]['filter4'])) {
                    if (this.profClass === "MAJ") {
                      var stepDescs = result.map(function (a) { return a['description']; });
                      if (stepDescs.indexOf(this.parentWorkflow.workflowDropdowns.options[i]['description']) < 0)
                        result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                    } else if (this.profClass !== "MAJ") {
                      result.push(this.parentWorkflow.workflowDropdowns.options[i]);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }else {
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListNivel")
          if (this.parentWorkflow.workflowDropdowns.options[i]['type'] === this.cardData.taxLevel)
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
      }
    }

    result.sort((a, b) => a.type.localeCompare(b.type, undefined, { numeric: true }));

    return result;
  }

  getCategories() {

    if (this.professionalClass === "4") {
      this.profClass = "DIPL";
      this.profGroup = "1";
    } else if (this.professionalClass === "5") {
      this.profClass = "MAJ";
      this.profGroup = "1";
    } else if (this.professionalClass === "17") {
      this.profClass = "MIL";
      this.profGroup = "1";
    }
    let result = [];
    if (this.profClass === "MIL") {
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListInferiorMIL") {
          result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }      
    } else if (this.profClass === "DIPL") {
      let end2005 = new Date(2005, 12, 31);
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListDipl") {
          if (end2005.getTime() <= new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter']).getTime() && end2005.getTime() >= new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']).getTime())
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    } else if (this.profClass === "MAJ") {
      let end2005 = new Date(2005, 12, 31);
      for (let i = 0; i < this.parentWorkflow.workflowDropdowns.options.length; i++) {
        if (this.parentWorkflow.workflowDropdowns.options[i]['dropdown'] === "dropListMaj") {
          if (end2005.getTime() <= new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter']).getTime() && end2005.getTime() >= new Date(this.parentWorkflow.workflowDropdowns.options[i]['filter2']).getTime())
            result.push(this.parentWorkflow.workflowDropdowns.options[i]);
        }
      }
    }

    if (this.profClass === "MIL" || this.profClass === "DIPL" || this.profClass === "MAJ")
      result = result.filter(taxIndex => taxIndex['type'] === this.profGroup);

    return result;
  }

  changedCategory(e) {
    if (this.profClass === "MIL" || this.profClass === "DIPL" || this.profClass === "MAJ") {
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i]['description'] === e) {
          this.chosenCategory = this.categories[i];
        }
      }
      if (this.checkCGDStarterEntity()) this.levels = this.getTaxLevels();
      else this.taxSteps = this.getTaxSteps();
    }  
  }

  public currencyFormat(value: any) {
    return CurrencyFormat(value);
  }

  checkMandatoryTaxStep() {
    if ((this.cardData.category !== undefined || this.cardData.taxLevel !== undefined) && !this.isExSubscritor)
      return true;

    if (this.isExSubscritor)
      return false;

    return false;
  }

  checkMandatoryTaxIndex() {
    if (this.cardData.taxStep !== undefined && !this.isExSubscritor)
      return true;

    if (this.isExSubscritor)
      return false;

    return false;
  }

}
